import React from 'react';

import {EventReviewFeedback} from 'src/modules/ai';
import {EVENT_CODE_FIELD_NAME} from 'src/modules/ai/constants';
import {EventCreationMode} from 'src/modules/event-create/constants';
import {EVENT_CODE_INFO} from 'src/modules/event-create/event-create-hovers';
import {SuggestEventCode} from 'src/modules/event-create/header-block/event-code/suggestEventCode/suggest-event-code';
import {HeaderBlock} from 'src/modules/event-create/typedefs';
import {eventCodeValidation} from 'src/modules/event-create/validations/event-code-validation';
import {EventChangeRequest} from 'src/openapi/models/EventChangeRequest';

import {Dropdown} from '@pb/kit-component-dropdown-v2';
import {Group, Item} from '@pb/kit-component-group';
import {InfoIconButton} from '@pb/kit-component-icon-button';
import {
    HorizontalPositionElement,
    PushNotification,
    VerticalPositionElement,
} from '@pb/kit-component-push-notification';

type Props = {
    headerValues: HeaderBlock,
    mode: EventCreationMode,
    eventChangeRequest: EventChangeRequest,
    changeRequestId: number | null,
    validationHighLight: boolean,
    onChangeField: (value: string, name?: string) => void,
};

export const EventCode = (props: Props) => {
    const {
        headerValues,
        mode,
        eventChangeRequest,
        changeRequestId,
        validationHighLight,
        onChangeField,
    } = props;

    const hasValidationError = Boolean(validationHighLight && eventCodeValidation(headerValues.code).length);

    return (
        <Group direction="v" gap="xxs" justify="space-between">
            <Group gap="xs" alignItems="center" justify="start">
                <strong>Event Code:</strong>
                <Dropdown
                    hoverEnabled={true}
                    clickEnabled={false}
                    maxWidth={500}
                    anchor={({anchorRef, getAnchorProps}) => (
                        <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                    )}>
                    {EVENT_CODE_INFO}
                </Dropdown>
                {mode === EventCreationMode.create && (
                    <EventReviewFeedback
                        changeRequestId={changeRequestId}
                        fieldName={EVENT_CODE_FIELD_NAME}
                    />
                )}
            </Group>
            <Group>
                <PushNotification anchorOrigin={{
                    horizontal: HorizontalPositionElement.RIGHT,
                    vertical: VerticalPositionElement.BOTTOM,
                }}>
                    <Item style={{width: '100%'}}>
                        <SuggestEventCode
                            eventChangeRequest={eventChangeRequest}
                            code={headerValues.code}
                            source={headerValues.source}
                            hasValidationError={hasValidationError}
                            mode={mode}
                            changeRequestId={changeRequestId}
                            onChange={onChangeField}
                        />
                    </Item>
                </PushNotification>
                <Item style={{width: '1rem'}}><span/></Item>
            </Group>
        </Group>
    );
};
